export default __webpack_public_path__ + "static/media/arrow-right.c453962b.svg";